import React from "react";
import { Skeleton } from "antd";
import { RiseOutlined } from "@ant-design/icons";
import { formatWithCommas } from "../../../assets/helpers";
import PanelCard from "./PanelCard";
import "./RecoveryPanel.scss";

const Ring = ({ value = 0, label, color }) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className="dsh-ring">
      <div
        className="dsh-ring__dial"
        style={{
          background: `conic-gradient(${color} ${pct * 3.6}deg, #eef1f8 ${pct * 3.6}deg)`,
        }}
      >
        <div className="dsh-ring__hole">
          <b>{pct}%</b>
        </div>
      </div>
      <span className="dsh-ring__label">{label}</span>
    </div>
  );
};

/**
 * Recovery snapshot — collection totals paired with the two conversion
 * ratios that matter most (callback -> PTP and PTP -> paid).
 */
const RecoveryPanel = ({ data = {}, loading = false }) => {
  const totals = [
    {
      label: "Total PTP Amount",
      value: formatWithCommas(data?.total_ptp_amount),
      accent: "blue",
    },
    {
      label: "Amount Collected",
      value: formatWithCommas(data?.amount_collected),
      accent: "green",
    },
  ];

  return (
    <PanelCard
      title="Recovery Performance"
      subtitle="Promise-to-pay pipeline and conversion health"
      icon={<RiseOutlined />}
      accent="green"
      className="dsh-recovery"
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 3 }} />
      ) : (
        <div className="dsh-recovery__grid">
          <div className="dsh-recovery__totals">
            {totals.map((t) => (
              <div className={`dsh-recovery__tile is-${t.accent}`} key={t.label}>
                <span className="dsh-recovery__tile-label">{t.label}</span>
                <span className="dsh-recovery__tile-value">{t.value}</span>
              </div>
            ))}
          </div>

          <div className="dsh-recovery__rings">
            <Ring
              value={data?.callback_to_ptp_conversion_percentage}
              label="Callback → PTP"
              color="#6287ff"
            />
            <Ring
              value={data?.ptp_to_paid_conversion_percentage}
              label="PTP → Paid"
              color="#ff6843"
            />
          </div>
        </div>
      )}
    </PanelCard>
  );
};

export default RecoveryPanel;
